import { Col, Grid, Row } from 'react-bootstrap'
import { getChi2RgURLbyModelListId, getNSDURLbyModelListId } from '../../../api/ispyb'

import FirContentPlotter from '../FirContentPlotter'
import FitContentPlotter from '../FitContentPlotter'
import ImageZoom from 'react-medium-image-zoom'
import PropTypes from 'prop-types'
import React from 'react'

class SaxsAbInitioUpperPanel extends React.Component {
  render() {
    const { subtraction } = this.props

    let NSDUrl = ''
    let chi2RgUrl = ''
    if (
      subtraction &&
      subtraction.subtractionId &&
      subtraction.abInitioModels instanceof Array &&
      subtraction.abInitioModels.length > 0 &&
      subtraction.abInitioModels[0].modelList &&
      subtraction.abInitioModels[0].modelList.modelListId
    ) {
      NSDUrl = getNSDURLbyModelListId(
        this.props.user,
        subtraction.subtractionId,
        subtraction.abInitioModels[0].modelList.modelListId
      )
      chi2RgUrl = getChi2RgURLbyModelListId(
        this.props.user,
        subtraction.subtractionId,
        subtraction.abInitioModels[0].modelList.modelListId
      )
    }

    return (
      <Grid fluid>
        <Row>
          <Col xs={12} md={12} lg={3}>
            <ImageZoom
              image={{
                src: NSDUrl,
                alt: 'NDS image',
                className: 'img',
                style: { display: 'block', maxWidth: '100%', height: 'auto', margin: 'auto' },
              }}
              zoomImage={{
                src: NSDUrl,
                alt: 'Scattering plot',
              }}
            />
          </Col>
          <Col xs={12} md={12} lg={3}>
            <ImageZoom
              image={{
                src: chi2RgUrl,
                alt: 'chi2Rg image',
                className: 'img',
                style: { display: 'block', maxWidth: '100%', height: 'auto', margin: 'auto' },
              }}
              zoomImage={{
                src: chi2RgUrl,
                alt: 'Scattering plot',
              }}
            />
          </Col>
          <Col xs={12} md={12} lg={3}>
            <FirContentPlotter data={this.props.firContent} />

            <div style={{ textAlign: 'center', fontStyle: 'italic', color: 'gray' }}>
              <span>
                Fit of the simulated scattering curve versus a smoothed experimental data (spline interpolation)
              </span>
            </div>
          </Col>
          <Col xs={12} md={12} lg={3}>
            <FitContentPlotter data={this.props.fitContent} />

            <div style={{ textAlign: 'center', fontStyle: 'italic', color: 'gray' }}>
              <span>Fit of the simulated scattering curve versus the experimental data.</span>
            </div>
          </Col>
        </Row>
      </Grid>
    )
  }
}

export default SaxsAbInitioUpperPanel

SaxsAbInitioUpperPanel.propTypes = {
  firContent: PropTypes.array,
  user: PropTypes.object,
}
